import React from "react"
import { useField } from "formik"

import ReactQuill from "react-quill-new"
import "react-quill-new/dist/quill.snow.css"

const EditorModules = {
    toolbar: [
        ["bold", "italic", "underline"],
        // The check list carries the "not included" marker: its unchecked state
        // is serialized as <li data-list="unchecked"> and drawn as a red X by
        // .plan-description, mirroring what the legacy hand-written markup did
        // with <i class="bi bi-x-lg text-danger"> (MGDWD-207).
        [{ list: "bullet" }, { list: "check" }, { list: "ordered" }],
        ["link"],
        ["clean"],
    ],
}

// Quill 2 registers bullet, check and ordered lists under the single "list"
// format, so the check list needs no separate entry here.
const EditorFormats = ["bold", "italic", "underline", "list", "link"]

// Quill 2's getSemanticHTML() serializes every regular space as &nbsp;
// (quill/quill#4509), which would block natural line wrapping wherever the
// saved HTML is rendered. Call this on the field value right before submitting.
// It must NOT run inside onChange: ReactQuill compares props.value against the
// exact string it last delivered and resets the editor (cursor jumps, collapsed
// double spaces) whenever they differ.
export const normalizeQuillHtml = (html) => (html || "").replace(/&nbsp;/g, " ")

// Quill represents an empty document as "<p><br></p>" (or "<p></p>" once
// serialized), so a truthy string check is not enough to know the field holds
// real content. String.trim() also strips non-breaking spaces (U+00A0), so
// entity-decoded NBSPs are covered.
export const richTextHasText = (html) => {
    if (!html) {
        return false
    }
    return html
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, " ")
        .trim()
        .length > 0
}

const CustomFormikQuillInput = ({ name, isInvalid }) => {
    const [field, , helpers] = useField(name)

    return (
        <div className={`rich-text-input${isInvalid ? " is-invalid" : ""}`}>
            <ReactQuill
                theme="snow"
                modules={EditorModules}
                formats={EditorFormats}
                value={field.value}
                onChange={(html) => helpers.setValue(html)}
                onBlur={() => helpers.setTouched(true)}
            />
        </div>
    )
}

export default CustomFormikQuillInput
